import {
  FETCH_WHAT_INCLUDES_DATA_INIT,
  FETCH_WHAT_INCLUDES_DATA_SUCCESS,
} from 'action-creators/payway/whatIncludes/constants';
import { apiCall } from 'api';
import { CMS_LEVEL_PATH_SERVICES } from 'api/services/content/paths';
import { getCmsLevel } from 'services/api/cms/level';
import api from 'services/api/microfwk';

export const fetchWhatIncludesCarousels = (family) => {
  return async dispatch => {
    try {
      dispatch({ type: FETCH_WHAT_INCLUDES_DATA_INIT });

          const { data: cmsLevelResponse } = await apiCall.get(
            CMS_LEVEL_PATH_SERVICES,
            {
              params: {
                user_hash: null,
                user_token: null,
                node: family, 
                type: 'abonos' 
              },
            },
          );

      const highlightResponse = await apiCall.get(cmsLevelResponse?.response?.modules?.module?.[0]?.components?.component?.[0]?.properties?.url);
      const primaryImage = highlightResponse?.data?.response?.highlight?.[0];
      const contentListResponse = await apiCall.get(cmsLevelResponse?.response?.modules?.module?.[1]?.components?.component?.[2]?.properties?.url);
      const secondaryImages = contentListResponse?.data?.response?.groups?.splice(0, 5);
      dispatch({ type: FETCH_WHAT_INCLUDES_DATA_SUCCESS, data: { primaryImage, secondaryImages  }, offer_type: cmsLevelResponse?.response?.metadata?.offer_type });
    }catch (e){
      console.log(e);
    }
  };
};
